import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=6e4beb28&"
import script from "./Costs.vue?vue&type=script&lang=ts&"
export * from "./Costs.vue?vue&type=script&lang=ts&"
import style0 from "./Costs.vue?vue&type=style&index=0&id=6e4beb28&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Guidance: require('C:/inetpub/wwwroot/bike-flights/components/guidance/Guidance.vue').default,Modal: require('C:/inetpub/wwwroot/bike-flights/components/Modal.vue').default})
